import { authorizeGetRequest, authorizePostRequest } from "api";
import { IPaginatedResponse, IDataResponse } from "models";
import { IActivityLog } from "models/activityLog";

export interface IActivityLogFilters {
  page: number;
  per_page: number;
  search?: string;
  action?: string;
  action_category?: "system" | "financial" | "security" | "business" | "driver" | "trip";
  from_date?: string;
  to_date?: string;
  account_role?: string;
  severity?: string;
  affected_driver_id?: string;
  affected_passenger_id?: string;
  trip_id?: string;
  before_state?: string;
  after_state?: string;
}

export interface IActivityLogStats {
  total_logs: number;
  severity_breakdown: {
    low: number;
    medium: number;
    high: number;
    critical: number;
  };
  action_breakdown: Record<string, number>;
  recent_activity: {
    last_hour: number;
    last_24_hours: number;
    last_7_days: number;
  };
  top_actions: Array<{ action: string; count: number }>;
}

export interface IActivityLogExportResponse {
  export_id: string;
  filename: string;
  record_count: number;
  download_url: string;
  expires_at: string;
}

export const activityLogApi = (filters: IActivityLogFilters) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      if (key === "search") value = value.toString().replace("+", "%2B");
      params.append(key, value.toString());
    }
  });

  return authorizeGetRequest<IPaginatedResponse<IActivityLog>>(`activity-logs?${params.toString()}`);
};

export const activityLogStatisticsApi = () => {
  return authorizeGetRequest<IDataResponse<IActivityLogStats>>(`activity-logs/statistics`);
};

export const exportActivityLogsApi = (params: any) => {
  const query = new URLSearchParams(params).toString();
  return authorizeGetRequest<IActivityLogExportResponse>(`activity-logs/export?${query}`);
};
